import React, { useContext, useEffect, useState } from "react";
import "../../../assests/css/admin/AdminDispuesSupport.css";
import Adminmasterlayout from "../../../layouts/Adminmasterlayout/Adminmasterlayout";
import axios from "axios";
import { AppContext } from "../../../context/Appcontext";
import { useNavigate } from "react-router-dom";

const AdminDisputesSupport = () => {
  const { baseUrl } = useContext(AppContext);
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("support");

  const [selectedTicket, setSelectedTicket] = useState(null);

  const [loading, setLoading] = useState(true);

  // Support Requests State
  const [supportRequests, setSupportRequests] = useState([]);
  const supportTickets = supportRequests.filter(
    (item) => item.request_type === "support"
  );

  const feeDisputes = supportRequests.filter(

    (item) => item.request_type === "fee_dispute"
  );

  const examQueries = supportRequests.filter(
    (item) => item.request_type === "exam_query"
  );
  console.log("Fee Disputes:", feeDisputes);

  // Load Data
  useEffect(() => {
    viewAllhelpsupport();
  }, []);

  // View All Help Support
  const viewAllhelpsupport = () => {
    setLoading(true);

    axios
      .get(`${baseUrl}/admin/helpsupport/viewAllhelpsupport`)

      .then((response) => {
        console.log(response.data);

        if (response.data.success === true) {
          setSupportRequests(response.data.request);
        }

        setLoading(false);
      })

      .catch((error) => {
        console.log(error);

        setLoading(false);
      });
  };

  return (
    <Adminmasterlayout>
      <div className="disputes-support-container">
        {/* Header */}
        <div className="ds-header">
          <h1 className="ds-title">Disputes & Support</h1>

          <p className="ds-subtitle">
            Manage tickets, disputes, and exam queries
          </p>
        </div>

        {/* Tabs */}
        <div className="ds-tabs">
          <button
            className={`tab-btn ${activeTab === "support" ? "active" : ""}`}
            onClick={() => setActiveTab("support")}
          >
            Support Tickets
          </button>

          <button
            className={`tab-btn ${activeTab === "disputes" ? "active" : ""}`}
            onClick={() => setActiveTab("disputes")}
          >
            Fee Disputes
          </button>

          <button
            className={`tab-btn ${activeTab === "exam" ? "active" : ""}`}
            onClick={() => setActiveTab("exam")}
          >
            Exam Result Queries
          </button>
        </div>

        {/* Content */}
        <div className="ds-content">
          {/* Support Tickets */}
          {activeTab === "support" && (
            <div className="ds-grid">
              {/* Stats */}
              <div className="ds-stats">
                <div className="stat-card">
                  <div className="stat-value">{supportRequests?.length}</div>

                  <div className="stat-label">Total Requests</div>
                </div>
              </div>

              {/* Loading */}
              {loading ? (
                <p className="loading-text">Loading...</p>
              ) : (
                /* Table */
                <div className="ds-table-wrapper">
                  <table className="ds-table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>User Type</th>
                        {/* <th>Name</th>
                        <th>Email</th> */}
                        <th>Issue</th>
                        <th>Description</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {supportRequests?.length > 0 ? (
                        supportRequests.map((ticket) => (
                          <tr key={ticket.id}>
                            <td className="ticket-id">{ticket.id}</td>

                            <td>
                              {ticket.ngteacher_id ? "Teacher" : "Student"}
                            </td>

                            {/* <td>
                              {ticket.name}
                            </td> */}

                            {/* <td>
                              {ticket.email}
                            </td> */}

                            <td>{ticket.selectissue}</td>

                            <td>{ticket.describeissue}</td>

                            <td>
                              <button
                                className="action-btn"
                                onClick={() =>
                                  navigate(`/admin/disputes/detail/${ticket.id}`)
                                }
                              >
                                View
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7">No Support Requests Found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Modal */}
        {selectedTicket && (
          <div
            className="modal-overlay"
            onClick={() => setSelectedTicket(null)}
          >
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h2>Ticket Details</h2>

                <button
                  className="close-btn"
                  onClick={() => setSelectedTicket(null)}
                >
                  ×
                </button>
              </div>

              <div className="modal-body">
                <div className="detail-row">
                  <span className="detail-label">ID:</span>

                  <span className="detail-value">{selectedTicket.id}</span>
                </div>

                <div className="detail-row">
                  <span className="detail-label">User Type:</span>

                  <span className="detail-value">
                    {selectedTicket.ngteacher_id ? "Teacher" : "Student"}
                  </span>
                </div>

                {/* <div className="detail-row">

                  <span className="detail-label">
                    Name:
                  </span>

                  <span className="detail-value">
                    {selectedTicket.name}
                  </span>

                </div> */}

                {/* <div className="detail-row">

                  <span className="detail-label">
                    Email:
                  </span>

                  <span className="detail-value">
                    {selectedTicket.email}
                  </span>

                </div> */}

                <div className="detail-row">
                  <span className="detail-label">Issue:</span>

                  <span className="detail-value">
                    {selectedTicket.selectissue}
                  </span>
                </div>

                <div className="detail-row">
                  <span className="detail-label">Description:</span>

                  <span className="detail-value">
                    {selectedTicket.describeissue}
                  </span>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  className="secondary-btn"
                  onClick={() => setSelectedTicket(null)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </Adminmasterlayout>
  );
};

export default AdminDisputesSupport;
